import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import { EditableFulfillmentPlanDate } from '../fulfillment-plan-dates/editable-fulfillment-plan-date';
import { ShipmentDetailsField } from '../field';
import messages from '../messages';
import { updateFulfillmentPlansPaidDate } from '../../../../../../fulfillment-plans/fulfillment-plans.api';
import { useFulfillmentPlanIdContext } from '../../../../../../fulfillment-plans/context/fulfillment-plan-id-context-provider';
import { useEntitiesFulfillmentPlanProperty } from '../../../../../../hooks/entities/selectors/fulfillment-plans';
import { useHasFulfillmentPlanRestriction } from '../../../restrictions-context';

const PaidDateFieldId = 'paid-date';

export const PaidDate = ({ disabled = false }) => {
  const fulfillmentPlanId = useFulfillmentPlanIdContext();
  const { paidDate } = useEntitiesFulfillmentPlanProperty(fulfillmentPlanId, 'fulfillmentPlanDates');

  const isRestricted = useHasFulfillmentPlanRestriction('paidDateTime');

  return (
    <ShipmentDetailsField label={<FormattedMessage {...messages.paidDate} />} labelFor={PaidDateFieldId}>
      <EditableFulfillmentPlanDate
        allowPastDates
        apiCall={updateFulfillmentPlansPaidDate}
        dateValueUtc={paidDate}
        disabled={disabled || isRestricted}
        fulfillmentPlanId={fulfillmentPlanId}
        id={PaidDateFieldId}
      />
    </ShipmentDetailsField>
  );
};

PaidDate.propTypes = {
  disabled: PropTypes.bool,
};
